var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#000",
    fillOpacity: 0.64,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.984 5h2.032c.22 0 .409 0 .565.01.165.012.33.037.493.104a1.5 1.5 0 0 1 .812.812c.067.163.092.328.103.493.011.156.011.346.011.565V7h2a.5.5 0 0 1 0 1h-1v4.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.48 16 11.92 16 10.8 16H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 14.48 6 13.92 6 12.8V8H5a.5.5 0 0 1 0-1h2v-.016c0-.22 0-.409.01-.565.012-.165.037-.33.104-.493a1.5 1.5 0 0 1 .812-.812c.163-.067.328-.092.493-.103C8.575 5 8.765 5 8.984 5M8 7h4c0-.24 0-.395-.008-.513a.6.6 0 0 0-.03-.178.5.5 0 0 0-.27-.27.6.6 0 0 0-.179-.03A9 9 0 0 0 11 6H9c-.24 0-.395 0-.513.008a.6.6 0 0 0-.178.03.5.5 0 0 0-.27.27.6.6 0 0 0-.03.179A9 9 0 0 0 8 7M7 8v4.8c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C8.25 15 8.623 15 9.2 15h1.6c.577 0 .949 0 1.232-.024.272-.022.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C13 13.75 13 13.377 13 12.8V8z",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;